import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommSchemeSetupReducer } from '../reducers';

export const selectCommSchemeSetupFeature =
  createFeatureSelector<CommSchemeSetupReducer.CommSchemeSetupState>(CommSchemeSetupReducer.featureName);

export const selectCommSchemeSetupDetail = createSelector(selectCommSchemeSetupFeature, ({ item }) => item);

export const selectCommSchemeSetupId = createSelector(selectCommSchemeSetupFeature, ({ item }) => item?.id);

export const selectSubmittingStatus = createSelector(
  selectCommSchemeSetupFeature,
  ({ submittingStatus }) => submittingStatus
);

